import { NavLink } from 'react-router-dom';
import { Button } from '../../Common';
import React from 'react';
import logo from '../../../assets/logo/logo.svg';
import { SubItem } from './Sidebar.types';
import { Menu_Item } from './MenuItem';
import { useLoginForm } from '@/hooks/useLoginForm';
import { useGlobalContextStore } from '@/store/GlobalContextStore/globalContextStore';

const Sidebar: React.FC = () => {
  const { isSidebarOpen, setIsSidebarOpen } = useGlobalContextStore();
  const { handleLogout } = useLoginForm();

  const MenuLabel = ({ label }: { label: string }) => (
    <span
      className={`text-white h-5 text-sm font-semibold uppercase ${isSidebarOpen ? 'opacity-1' : 'opacity-0'} transition-opacity duration-300 my-4`}
    >
      {label}
    </span>
  );

  const SubMenuItem = ({ icon, label, to }: SubItem) => (
    <li className="cursor-pointer" onClick={() => setIsSidebarOpen(true)}>
      <NavLink
        to={to}
        className={({
          isActive,
        }) => `w-full flex justify-between py-3 px-[25px] hover:bg-[#232323] hover:border-l-primary hover:border-solid hover:border-l-[2px]
        ${isActive ? 'text-primary border-l-primary border-solid border-l-[2px]' : 'text-[#939393]'}
      `}
      >
        <div className="flex items-center">
          <i className={`${icon} text-xl pr-[9px]`} />
          {isSidebarOpen && <span>{label}</span>}
        </div>
        {isSidebarOpen && <i className="pi pi-angle-right text-xl" />}
      </NavLink>
    </li>
  );

  return (
    <aside
      className={`fixed top-0 left-0 h-screen bg-black text-gray-400 ${
        isSidebarOpen ? 'w-[298px]' : 'w-[92px]'
      } transition-all duration-300 flex flex-col`}
    >
      <div className="w-[93%] flex flex-col mx-auto h-full">
        <div className="flex items-center justify-between mt-10 ml-[25px] mb-[25px]">
          <div className="flex text-white text-2xl font-bold">
            <img src={logo} alt="Logo Yelloapp" className="mr-4" />{' '}
            <span
              className={`text-2xl font-[700] transition-opacity duration-300 ${
                isSidebarOpen ? 'opacity-100' : 'opacity-0'
              }`}
            >
              Yello
            </span>
          </div>
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="text-[#939393] hover:text-primary focus:outline-none"
          >
            {isSidebarOpen && (
              <i className={`pi pi-angle-double-left text-lg`} />
            )}
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto scrollbar-hidden">
          <ul>
            {Menu_Item.map((item, index) => (
              <li key={index} className="whitespace-nowrap overflow-hidden">
                <div className="flex items-center px-[25px]">
                  <MenuLabel label={item.label} />
                </div>
                {item.subItems.length > 0 && (
                  <ul>
                    {item.subItems.map((subItem, subIndex) => (
                      <SubMenuItem key={subIndex} {...subItem} />
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="pt-[50px] pb-5">
          <Button
            className={`!bg-[#1E1700] text-primary ml-[20px] justify-evenly ${
              isSidebarOpen ? 'w-[200px]' : 'w-[50px]'
            } h-[50px]`}
            icon={<i className="pi pi-sign-out"></i>}
            iconPosition="left"
            onClick={handleLogout}
            title={isSidebarOpen ? 'Déconnexion' : ''}
          />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
